import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Button,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap"
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useForm from "../../../lib/useForm"
import Loading from 'lib/loading'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const formSwal = withReactContent(Swal)

const FormEstabelecimento = ({ fechaModal, estabelecimento_id}) => {

  //valores iniciais do formulario
  const inicialForm = {
    estabelecimento_id: '',
    estabelecimento: ''
  }

  const [form, onChange, setForm] = useForm(inicialForm)
  const [loading, setLoading]     = useState(true)

  //preenche setform e formulario
  const editEstabelecimento = (estabelecimento_id) => {
    const url     = rotas.estabelecimento+estabelecimento_id,
          retorno = rest.get(url)

    retorno.then(ret => {
      if (ret.success && ret.success == 'S' && ret.lista !== '') {
        setForm(ret.lista[0])
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if(estabelecimento_id != ''){
      editEstabelecimento(estabelecimento_id)
    }else{
      setForm(inicialForm)
      setLoading(false)
    }
  },[])

  const excluir = () => {
    if(estabelecimento_id != ''){
      // console.log(estabelecimento_id)

      formSwal.queue([{
        title:                'Deseja excluir o estabelecimento ?',
        confirmButtonText:    'SIM',
        showCancelButton:     true,
        text:                 'Essas informações serão excluidas do banco',
        showLoaderOnConfirm:  true,
        cancelButtonColor:    '#d33',
        preConfirm: () => {
          // setLoading(true)
          // console.log('confirmou')
          const param = {'estabelecimento_id': estabelecimento_id}
          const url = rotas.estabelecimento+estabelecimento_id
          try{
            const retorno = rest.del(url, param)
            retorno.then(ret => {
              // console.log(ret)
              if (ret.success && ret.success == 'S') {
                formSwal.fire('Salvo!', ret.msg, 'success')
                fechaModal()
              }else{
                formSwal.fire('Erro!',ret.msg,'error')
              }
            })
            return (true)
          }catch(err){
            console.log(err)
            formSwal.fire('Erro!',err,'error')
          }
        }
      }])
    }
  }

  //SUBMIT
  const handleSubmit = (evt) => {
    evt.preventDefault()

    formSwal.queue([{
      title: 'Deseja salvar ?',
      confirmButtonText: 'Salvar',
      showCancelButton: true,
      text:'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        const url = rotas.estabelecimento+'gravar.php'
        // console.log(form)
        if(estabelecimento_id !== ''){
          return rest.post(url, form)
            .then(ret => {
              if (ret.success == 'S') {
                editEstabelecimento(estabelecimento_id)
                formSwal.fire('Salvo!',
                              ret.msg,
                              'success')
              }else{
                formSwal.fire('Erro!',
                              ret.msg,
                              'error')
              }
            })
        }else{
          return rest.put(url, form)
            .then(ret => {
              if (ret.success == 'S') {
                editEstabelecimento(ret.retorno.insert_id)
                formSwal.fire('Salvo!',
                              ret.msg,
                              'success')
              }else{
                formSwal.fire('Erro!',
                              ret.msg,
                              'error')
              }
            })
        }
      }
    }])
  }

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading
          tipo='componente'
        />
      </ModalBody>
    )
  }else {
    return (
      <FormGroup onSubmit={handleSubmit} className="formCadastro">
        <ModalBody className="pb-0">
          <Form>
            <Row>
              <Col md ='2'>
                <FormGroup>
                  <Label for="estabelecimento_id">Código</Label>
                  <Input
                    disabled
                    style     = {{background: '#F9F9F9'}}
                    name      = "estabelecimento_id"
                    id        = "estabelecimento_id"
                    value     = {form.estabelecimento_id}
                    onChange  = {onChange('estabelecimento_id')}
                  />
                </FormGroup>
              </Col>
              <Col md ='10'>
                <FormGroup>
                  <Label for="estabelecimento">Estabelecimento</Label>
                  <Input
                    name        = "estabelecimento"
                    id          = "estabelecimento"
                    maxLength   = {50}
                    value       = {form.estabelecimento}
                    onChange    = {onChange('estabelecimento')}
                    placeholder = "Nome do estabelecimento..."
                  />
                </FormGroup>
              </Col>
            </Row>

            <Col className="text-center p-3">
              <Button type="submit" className="mb-0 mt-0" color="success" size="md" >Salvar</Button>
              <Button type="button" className="mb-0 mt-0" color="danger" size="md" onClick={() => excluir()}>Excluir</Button>
              <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>Fechar</Button>
            </Col>

          </Form>
        </ModalBody>
      </FormGroup>
    )
  }


}

export default FormEstabelecimento
